import useDSApplicationMode from './useDSApplicationMode'

export const STATION_MODE = 'STATION'

// Thin, named wrapper around useDSApplicationMode() so experiences ask "are we in
// STATION/kiosk mode?" the same way instead of repeating the `appMode === 'STATION'`
// string comparison at every call site.
export default function useIsStationMode() {
  const appMode = useDSApplicationMode()

  return appMode === STATION_MODE
}
